import {Component} from '@angular/core';
import {
  handlePasteWithoutLeadingSpaces,
  preventLeadingSpaceKey
} from "../../../../../core/utils/input-validation.utils";
import {ParentWithMultipleChildren} from "../../../../../api/models/parent-with-multiple-children";
import {InsiderRelationshipMappingService} from "../../../../../api/services/insider-relationship-mapping.service";
import {InsiderRelationshipMappingFilter} from "../../../../../api/models/insider-relationship-mapping-filter";

@Component({
  selector: 'app-more-than-one-child',
  templateUrl: './more-than-one-child.component.html',
  styleUrl: './more-than-one-child.component.css',
  standalone: false
})
export class MoreThanOneChildComponent {

  list = [] as ParentWithMultipleChildren[];
  first = 0;
  readonly paginator = {pageSize: 10, pageNumber: 1, totalCount: 0};
  isLoading = false;
  filters = {pageNumber: 1, pageSize: 10} as InsiderRelationshipMappingFilter;
  private rows = 10;

  constructor(private _insiderRelationService: InsiderRelationshipMappingService) {
  }

  onSearch() {
    this.filters.pageNumber = 1;
    this.first = 0;
    this.doTheSearchNow();
  }

  preventSpaceKey(event: KeyboardEvent): void {
    preventLeadingSpaceKey(event);
  }

  onPaste(event: ClipboardEvent, control: any): void {
    handlePasteWithoutLeadingSpaces(event, (newValue: string) => {
      control.value = newValue;
    });
  }

  loadData(event: any) {
    if (this.first > 0 && this.paginator.pageSize !== event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.filters.pageNumber = this.paginator.pageNumber;
    this.filters.pageSize = this.paginator.pageSize;
    this.doTheSearchNow();
  }

  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  private doTheSearchNow() {
    this.isLoading = true;
    this._insiderRelationService.getMultipleChildrenRelationships(this.filters)
      .subscribe({
        next: value => {
          if (!value) return;
          this.list = value;
          this.paginator.totalCount = value?.at(0)?.totalCount ?? 0;
        },
        complete: () => {
          this.isLoading = false;
        }
      });
  }
}
